import React, { useState, useRef, useMemo, useCallback } from "react";
import "./style.scss";

import HeaderMenu from "./Component/HeaderMenu";
import ReviewContent from "./Component/ReviewContent";
import GlobalWatermark from "util/component/GlobalWatermark";
import { useSelector } from "react-redux";

const Review = () => {
	const [Data, SetData] = useState(null);
	const userSelector = useSelector((store) => store.user);
	const common = useSelector((store) => store.common);
	const isExternal = common.external === "true";

	return (
		<div className={"bpl-container"}>
			{isExternal && <GlobalWatermark text={userSelector.userId} />} 
			<section className={"review"}>
				<HeaderMenu SetData={SetData} />
				<ReviewContent {...Data} />
			</section>
		</div>
	);
};

export default Review;
